import React from "react";
import { LineHorizontal } from "./components/LineHorizontal";
import { LineVertical } from "./components/LineVertical";
import { ChartGridType, chartType, ChartViewType, IDynamicChartsProps } from "src/pages/Insights/models/interfaces";
import { Empty } from "src/assets/imports/antdComponents";
import { QuantComponentsRenderedFromType } from "src/pages/NewAskKural/models/interfaces";

const LineCharts: React.FC<IDynamicChartsProps> = ({
	obj,
	type,
	config,
	isMini,
	legends = [],
	showYAxisLabel = true,
	showXAxis = true,
	maxDomain = "auto",
	minDomain = "auto",
	chartSegmentLength = 1,
	renderedFrom = QuantComponentsRenderedFromType.Quant,
	isSectionalSummary = false,
	viewType = ChartViewType.Dashboard,
	grid = ChartGridType.oneXone
}) => {
	switch (String(type)?.toLowerCase()) {
		case chartType.Line_Horizontal?.toLocaleLowerCase():
			return (
				<LineHorizontal
					obj={obj}
					type={type}
					config={config}
					isMini={isMini}
					legends={legends}
					showYAxisLabel={showYAxisLabel}
					showXAxis={showXAxis}
					maxDomain={maxDomain}
					minDomain={minDomain}
					renderedFrom={renderedFrom}
					isSectionalSummary={isSectionalSummary}
					chartSegmentLength={chartSegmentLength}
					viewType={viewType}
					grid={grid}
				/>
			);
		case chartType.Line_Vertical?.toLocaleLowerCase():
			return (
				<LineVertical
					obj={obj}
					type={type}
					config={config}
					isMini={isMini}
					legends={legends}
					showYAxisLabel={showYAxisLabel}
					showXAxis={showXAxis}
					maxDomain={maxDomain}
					minDomain={minDomain}
					chartSegmentLength={chartSegmentLength} // Add this prop
					isSectionalSummary={isSectionalSummary}
					renderedFrom={renderedFrom}
					viewType={viewType}
					grid={grid}
				/>
			);
		default:
			return (
				<div className="flex justify-center h-full align-middle empty-center">
					<Empty />
				</div>
			);
	}
};

export default LineCharts;
